import { createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "grid formgrid" }
const _hoisted_2 = { class: "col-4 xl:col-3 md:col-4 field p-fluid" }
const _hoisted_3 = { class: "col-4 xl:col-3 md:col-4 field p-fluid" }
const _hoisted_4 = { class: "col-4 xl:col-3 md:col-4 field p-fluid" }
const _hoisted_5 = { class: "col-4 xl:col-2 md:col-3 field flex flex-column justify-content-end" }
const _hoisted_6 = { class: "col-12" }
const _hoisted_7 = { class: "grid" }
const _hoisted_8 = { class: "col-12 md:col-3 p-fluid mt-2" }
const _hoisted_9 = { class: "p-float-label" }
const _hoisted_10 = { class: "flex justify-content-between" }
const _hoisted_11 = { class: "btngrp" }
const _hoisted_12 = {
  class: "flex flex-row justify-content-end",
  width: "100%"
}
const _hoisted_13 = { style: {"width":"100%","height":"85vh"} }
const _hoisted_14 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Card = _resolveComponent("Card")!
  const _component_shipment_map = _resolveComponent("shipment-map")!
  const _component_Sidebar = _resolveComponent("Sidebar")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Card, { class: "m-2" }, {
      title: _withCtx(() => [
        _withDirectives((_openBlock(), _createElementBlock("span", null, _cache[6] || (_cache[6] = [
          _createTextVNode(" Shipment Report ")
        ]))), [
          [_directive_tooltip, `สำหรับตรวจสอบ สถานะของ Shipment และปิด Shipment แบบ Manual`]
        ])
      ]),
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _cache[7] || (_cache[7] = _createElementVNode("label", { for: "selectedDate" }, "Create Date", -1)),
            _createVNode(_component_Calendar, {
              id: "selectedDate",
              selectionMode: "range",
              modelValue: _ctx.selectedDate,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedDate) = $event)),
              autocomplete: "off"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _cache[8] || (_cache[8] = _createElementVNode("label", { for: "dselectedDate" }, "Deliverry Date", -1)),
            _createVNode(_component_Calendar, {
              id: "dselectedDate",
              selectionMode: "range",
              modelValue: _ctx.dselectedDate,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dselectedDate) = $event)),
              autocomplete: "off"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _cache[9] || (_cache[9] = _createElementVNode("label", { for: "shipmentNo" }, "Shipment No", -1)),
            _createVNode(_component_InputText, {
              id: "shipmentNo",
              modelValue: _ctx.shipmentNo,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.shipmentNo) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Button, {
              icon: "pi pi-search",
              label: "ดึงข้อมูล",
              onClick: _ctx.onSearch
            }, null, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_DataTable, {
              class: "p-datatable-sm",
              value: _ctx.filteredShipments,
              sortMode: "multiple",
              paginator: "",
              rows: 10,
              dataKey: "shipmentNo"
            }, {
              empty: _withCtx(() => _cache[10] || (_cache[10] = [
                _createTextVNode(" ไม่พบข้อมูล ")
              ])),
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("span", _hoisted_9, [
                      _createVNode(_component_InputText, {
                        id: "searchString",
                        modelValue: _ctx.searchString,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchString) = $event)),
                        class: "p-inputtext-sm"
                      }, null, 8, ["modelValue"]),
                      _cache[11] || (_cache[11] = _createElementVNode("label", { for: "searchString" }, "ค้นหาข้อมูลในตารางด้านล่าง", -1))
                    ])
                  ])
                ])
              ]),
              footer: _withCtx(() => [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("span", null, "จำนวนรายการทั้งหมด " + _toDisplayString(_ctx.shipments.length) + " รายการ", 1),
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_Button, {
                      icon: "pi pi-download",
                      class: "p-button-sm p-button-success",
                      label: "Excel",
                      onClick: _ctx.onDownloadExcel,
                      disabled: _ctx.shipments.length === 0
                    }, null, 8, ["onClick", "disabled"]),
                    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "gap" }, null, -1)),
                    _withDirectives(_createVNode(_component_Button, {
                      icon: "pi pi-download",
                      class: "p-button-sm p-button-success",
                      label: "Excel Detail",
                      disabled: _ctx.shipments.length === 0,
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onShowDetail('Multiple')))
                    }, null, 8, ["disabled"]), [
                      [_directive_tooltip, `แสดงรายละเอียดการเข้าเยี่ยมทั้งหมด`]
                    ])
                  ])
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_Column, {
                  field: "shipmentNo",
                  header: "เลขที่ Shipment",
                  sortable: ""
                }, {
                  body: _withCtx((props) => [
                    _createTextVNode(_toDisplayString(parseInt(props.data.shipmentNo)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "plant",
                  header: "สาขา",
                  sortable: ""
                }),
                _createVNode(_component_Column, {
                  field: "owner",
                  header: "Dman",
                  sortable: ""
                }),
                _createVNode(_component_Column, {
                  field: "ownerName",
                  header: "ชื่อ Dman",
                  sortable: ""
                }),
                _createVNode(_component_Column, {
                  field: "createOn",
                  header: "วันที่สร้าง Shipment",
                  sortable: ""
                }, {
                  body: _withCtx((props) => [
                    _createTextVNode(_toDisplayString(_ctx.formatDateTime(props.data.createOn)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "deliveryDate",
                  header: "วันที่ส่ง",
                  sortable: ""
                }, {
                  body: _withCtx((props) => [
                    _createTextVNode(_toDisplayString(_ctx.formatDate(props.data.deliveryDate)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "completeOn",
                  header: "วันที่สิ้นสุด",
                  sortable: ""
                }, {
                  body: _withCtx((props) => [
                    _createTextVNode(_toDisplayString(_ctx.formatDateTime(props.data.completeOn)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "totalBilling",
                  header: "จำนวนบิลทั้งหมด",
                  sortable: "",
                  bodyStyle: "text-align:right",
                  headerStyle: "text-align:right"
                }),
                _createVNode(_component_Column, {
                  field: "paidBilling",
                  header: "จำนวนบิลที่สำเร็จแล้ว",
                  sortable: "",
                  bodyStyle: "text-align:right",
                  headerStyle: "text-align:right"
                }),
                _createVNode(_component_Column, {
                  field: "haulBack",
                  header: "จำนวน Haulback",
                  bodyStyle: "text-align:right",
                  headerStyle: "text-align:right",
                  sortable: ""
                }),
                _createVNode(_component_Column, {
                  field: "maximumSpeed",
                  header: "ความเร็วสูงสุด(KM/H)",
                  bodyStyle: "text-align:right",
                  headerStyle: "text-align:right",
                  sortable: ""
                }, {
                  body: _withCtx((props) => [
                    _createTextVNode(_toDisplayString(_ctx.formatAmount(props.data.maximumSpeed)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "distance",
                  header: "ระยะทาง(KM)",
                  bodyStyle: "text-align:right",
                  headerStyle: "text-align:right",
                  sortable: ""
                }, {
                  body: _withCtx((props) => [
                    _createTextVNode(_toDisplayString(_ctx.formatAmount(props.data.distance / 1000)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  bodyStyle: "min-width: 10:rem",
                  headerStyle: "min-width:10rem"
                }, {
                  body: _withCtx((props) => [
                    _createElementVNode("div", _hoisted_12, [
                      _withDirectives(_createVNode(_component_Button, {
                        icon: "pi pi-map",
                        class: "p-button-rounded p-button-info",
                        onClick: ($event: any) => (_ctx.onShowMap(props.data.shipmentNo))
                      }, null, 8, ["onClick"]), [
                        [_directive_tooltip, `แสดงแผนที่`]
                      ]),
                      _withDirectives(_createVNode(_component_Button, {
                        icon: "pi pi-list",
                        class: "p-button-rounded p-button-info ml-1",
                        onClick: ($event: any) => (_ctx.onShowDetail(props.data.shipmentNo))
                      }, null, 8, ["onClick"]), [
                        [_directive_tooltip, `แสดงรายละเอียดการเข้าเยี่ยม`]
                      ]),
                      (!props.data.isComplete)
                        ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                            key: 0,
                            icon: "pi pi-fast-forward",
                            class: "p-button-rounded p-button-danger ml-1",
                            onClick: ($event: any) => (_ctx.onCompleteShipment(props.data.shipmentNo))
                          }, null, 8, ["onClick"])), [
                            [
                              _directive_tooltip,
                              `ทำการปิด Shipment`,
                              void 0,
                              { left: true }
                            ]
                          ])
                        : _withDirectives((_openBlock(), _createBlock(_component_Button, {
                            key: 1,
                            class: "p-button-rounded ml-1 p-button-success",
                            icon: "pi pi-check"
                          }, null, 512)), [
                            [
                              _directive_tooltip,
                              `Shipment เสร็จสิ้นแล้ว`,
                              void 0,
                              { left: true }
                            ]
                          ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, 1032, ["value"])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_Sidebar, {
      visible: _ctx.showMap,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showMap) = $event)),
      position: "full"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_13, [
          ((_ctx.selectedShipment && !_ctx.showmultipe) || (_ctx.shipmentList && _ctx.showmultipe))
            ? (_openBlock(), _createBlock(_component_shipment_map, {
                key: 0,
                shipmentNo: _ctx.selectedShipment,
                showDetail: _ctx.showShipmentDetail,
                showmultipe: _ctx.showmultipe,
                shipmentList: _ctx.shipmentList
              }, null, 8, ["shipmentNo", "showDetail", "showmultipe", "shipmentList"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_14, "กรุณาระบุเลข Shipment ก่อน"))
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}